<template>
  <div class="textbook">
      <Header title="教材订购"></Header>
      <div class="textbook_content">
        <NOdata title="未查询到选课数据~" v-if="this.xkjgList.length == 0"></NOdata>
        <template v-else>
          <RouterLink v-for="(item,index) in xkjgList" :key="index" :to="{path:'/student/xsxkjcDg_jcxz',query:{info:JSON.stringify(item)}}">
            <div class="xkjg_list">
              <h4>({{item.KCH}}){{item.KCMC}}</h4>
              <table>
                <tr>
                  <td>
                    <span >课程属性:{{item.KCLB}}</span>
                  </td>
                  <td>
                    <span >学分:{{item.XF}}</span>
                  </td>
                  <td>
                    <span >上课教师:{{item.JGXM}}</span>
                  </td>
                </tr>
              </table>
            </div>
          </RouterLink>
        </template>
      </div>
  </div>
</template>

<script>
  import { Api } from '../../../utils/axios'
  export default {
    data(){
      return{
        xkjgList:[]
      }
    },
    methods:{
      async getList(){
        const res = await Api.jcdgxkjgList()
        if(res.code == '0'){
          
        }else{
          this.xkjgList = res.data;
        }
      }
    },
    created() {
      this.getList()
    }
  }
</script>

<style lang="less" scoped>
  .textbook .van-dropdown-menu{width: 65%;}
  .textbook .textbook_content{padding: 10px 20px;}
  .textbook .textbook_search{width: 100%;height: 44px;background: @attendance-background-color-6;display: flex;align-items: center;border-radius:3px;box-sizing: border-box;padding: 0 15px;}
  .textbook .textbook_search .icon_search{width: 20px;height: 20px;background: url(../../../../static/img/search.png) no-repeat;background-size: 100%;margin-right: 11px;}
  .textbook .textbook_search input{background: none;}
  .textbook .textbook_select{display: flex;justify-content: center;align-items: center;border-bottom: 1px solid @attendance-border-color-6;padding: 20px 0 7px;}
  .textbook .textbook_select select{border: 0;background: 0;outline: 0;}
  .textbook .xkjg_list{padding: 0 20px;background:rgba(248,248,248,1);border-radius:5px;margin-top: 20px;min-height: 82px;display: flex;flex-direction: column;justify-content: center;}
  .textbook .xkjg_list h4{font-size: 16px;line-height: 22px;color: @attendance-color-1;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;margin-bottom: 4px;}
  .textbook .xkjg_list span{color: @attendance-color-2;font-size: 12px;line-height: 17px;}
  .textbook .el-select{width: 40%;}
  .textbook .el-input__inner{border: 0;}
  .textbook .el-input--suffix .el-input__inner{overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}

  .textbook_select .sem-drop{width: 80%;}
  .textbook_select .van-picker-column__item{margin: 0 30%;}
  .textbook_select .sem-drop>div{width: 45%;}
  .textbook_select .van-popup.van-popup--bottom{border-radius: 5px 5px 0 0;}
  .textbook_select .sem-drop p{overflow: hidden;text-overflow: ellipsis;white-space: nowrap;text-align: right;}
  .textbook_select .sem-drop,.textbook_select .sem-drop div{display: flex;align-items: center;color: @attendance-color-2;font-size: 14px;justify-content: center;}
  .textbook_select .sem-drop>div i{background: url(../../../../static/img/Triangle.png)no-repeat center;width: 10px;height: 10px;background-size: 10px 8px;margin-left: 5px;}
  .textbook_select .van-ellipsis.van-picker-column__item.van-picker-column__item--selected{font-weight: 600;color: @attendance-color-1;}

  .textbook_select .van-picker__columns::before{width: 140px;height: 1px;background-color: @attendance-background-color-2;content: '';position: absolute;top: 70px;left: 50%;transform: translateX(-50%)}
  .textbook_select .van-picker__columns::after{width: 140px;height: 1px;background-color: @attendance-background-color-2;content: '';position: absolute;bottom: 70px;left: 50%;transform: translateX(-50%)}

</style>



// WEBPACK FOOTER //
// src/components/student/jcdg/xsxkjcDg.vue